
import { UserDto } from './userDto';

export class CaseSummarySearchFilter {
  typeItems: string[];
  dateRange: Date[];
  users: UserDto[];
  searchText: string;
}
